import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import translationArabic from './locales/Arabic/translation.json';
import translationEnglish from './locales/English/translation.json';

var options = {
    // order and from where user language should be detected
    order: ['path','localStorage'],
    // keys or params to lookup language from
    lookupLocalStorage: 'i18nextLng',
    lookupFromPathIndex: 0,
    // cache user language on
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
    checkWhitelist: true
};

let language = localStorage.getItem('i18nextLng');

i18n
.use(LanguageDetector)
.init({
    lng: language ? language : 'english',
    debug: false,
    detection: options,
    whitelist: ["arabic", "english"],
    interpolation: {
        escapeValue: false, // not needed for react
        formatSeparator: ","
    },
    resources: {
        arabic: {
            translations: translationArabic
        },
        english: {
            translations: translationEnglish
        }
    },
    fallbackLng: "english",
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations"
});

export default i18n;